import { render, staticRenderFns } from "./appointmentIndex.vue?vue&type=template&id=54d15738&scoped=true&"
import script from "./appointmentIndex.vue?vue&type=script&lang=js&"
export * from "./appointmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./appointmentIndex.vue?vue&type=style&index=0&id=54d15738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d15738",
  null
  
)

export default component.exports